// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCssJs$PrezzeeRibbon from "../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../theme/Theme__Color.bs.js";
import * as ThemeContext__Components$PrezzeeRibbon from "./ThemeContext__Components.bs.js";

function t(primaryOpt, secondaryOpt, tertiaryOpt, displayFontOpt, headingFontOpt, bodyFontOpt, borderRadiusOpt, componentsOpt, param) {
  var primary = primaryOpt !== undefined ? primaryOpt : ({
        default: Theme__Color$PrezzeeRibbon.red400,
        defaultText: Theme__Color$PrezzeeRibbon.white,
        hover: Theme__Color$PrezzeeRibbon.red500,
        hoverText: Theme__Color$PrezzeeRibbon.white
      });
  var secondary = secondaryOpt !== undefined ? secondaryOpt : ({
        default: Theme__Color$PrezzeeRibbon.purple400,
        defaultText: Theme__Color$PrezzeeRibbon.white,
        hover: Theme__Color$PrezzeeRibbon.purple600,
        hoverText: Theme__Color$PrezzeeRibbon.white
      });
  var tertiary = tertiaryOpt !== undefined ? tertiaryOpt : ({
        default: Theme__Color$PrezzeeRibbon.gray700,
        defaultText: Theme__Color$PrezzeeRibbon.white,
        hover: Theme__Color$PrezzeeRibbon.gray800,
        hoverText: Theme__Color$PrezzeeRibbon.white
      });
  var displayFont = displayFontOpt !== undefined ? displayFontOpt : [
      {
        NAME: "custom",
        VAL: "DM Serif Display"
      },
      {
        NAME: "custom",
        VAL: "sofia-pro"
      },
      "sansSerif"
    ];
  var headingFont = headingFontOpt !== undefined ? headingFontOpt : [
      {
        NAME: "custom",
        VAL: "sofia-pro"
      },
      "sansSerif"
    ];
  var bodyFont = bodyFontOpt !== undefined ? bodyFontOpt : [
      {
        NAME: "custom",
        VAL: "sofia-pro"
      },
      "sansSerif"
    ];
  var borderRadius = borderRadiusOpt !== undefined ? borderRadiusOpt : BsCssJs$PrezzeeRibbon.px(4);
  var components = componentsOpt !== undefined ? componentsOpt : ThemeContext__Components$PrezzeeRibbon.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  return {
          primary: primary,
          secondary: secondary,
          tertiary: tertiary,
          displayFont: displayFont,
          headingFont: headingFont,
          bodyFont: bodyFont,
          borderRadius: borderRadius,
          components: components
        };
}

export {
  t ,
}
/* BsCssJs-PrezzeeRibbon Not a pure module */
